{
  "demo": {
    "searchPlaceholder": "Søk...",
    "searchAriaLabel": "Søk i listen",
    "filterLabel": "Filter",
    "filterAllLabel": "Alle",
    "filterSearchPlaceholder": "Søk...",
    "filterNoResultsText": "Ingen treff",
    "resetLabel": "Nullstill",
    "countLabel": "Viser {{visible}} av {{total}}",
    "rowsPerPageLabel": "Rader per side"
  }
}
